import React, { Component } from 'react'
import { sagaModal } from 'redux-saga-modal'
import {  Modal,Tabs,List, Button } from 'antd'
import styles from './couponDialog.module.scss';
import cn from 'classnames';
import dayjs from 'dayjs';
import * as apis from '@/apis'
const { TabPane } = Tabs;
class CouponDialogComponent extends Component {
  state = {
    loading: false,
    unUsed: [],
    used:[],
    invalid:[]
  }
 getCoupons = async () => {
  const unUsed = await apis.fetchTenantCoupons(0);
  this.setState({unUsed:unUsed})
  const used = await apis.fetchTenantCoupons(1);
  this.setState({used:used})
  const invalid = await apis.fetchTenantCoupons(2);
  this.setState({invalid:invalid})
 }
  componentDidMount() {
    this.getCoupons();
  }
  render() {
    const {  coupon = {},disabled } = this.props
    function callback(key) {
        console.log(key);
    }
    return (
      <Tabs defaultActiveKey="1" onChange={callback}>
        <TabPane tab="未使用" key="1">
        <List grid={{ gutter: 2, column: 2 }}
      dataSource={this.state.unUsed}
      renderItem={item => (
        <List.Item>
          <div className={cn( styles.stamp01,styles.stamp)}>
          <div className={styles.par}><p>{item.cashCoupon.name}</p><sub className={styles.sign}>￥</sub><span>{item.cashCoupon.coupons}</span><sub>代金券</sub><p>{item.cashCoupon.memo}</p></div>
          <div className={styles.copy}>有效期
              <p>{dayjs(item.createdAt).format('YYYY-MM-DD')}</p><p>{dayjs(item.expiration).format('YYYY-MM-DD')}</p>
              </div>
          <i></i>
          </div>
        </List.Item>
      )}
    />
        </TabPane>
        <TabPane tab="已使用" key="2">
        <List grid={{ gutter: 2, column: 2 }}
      dataSource={this.state.used}
      renderItem={item => (
        <List.Item>
        <div className={cn(styles.stamp02,styles.stamp)}>
		<div className={styles.par}><p>{item.cashCoupon.name}</p><sub className={styles.sign}>￥</sub><span>{item.cashCoupon.coupons}</span><sub>代金券</sub><p>{item.cashCoupon.memo}</p></div>
		<div className={styles.used}>使用日期
        <p>{dayjs(item.useAt).format('YYYY-MM-DD')}</p>
        订单编号
        <p>{item.order.order_no}</p>
        </div>
		<i></i>
	    </div>
      </List.Item>
      )}
      />
        </TabPane>
        <TabPane tab="已过期" key="3">
        <List grid={{ gutter: 2, column: 2 }}
      dataSource={this.state.invalid}
      renderItem={item => (
        <List.Item>
        <div className={cn(styles.stamp03,styles.stamp)}>
		<div className={styles.par}><p>{item.cashCoupon.name}</p><sub className={styles.sign}>￥</sub><span>{item.cashCoupon.coupons}</span><sub>代金券</sub><p>{item.cashCoupon.memo}</p></div>
    <div className={styles.copy}>有效期
              <p>{dayjs(item.createdAt).format('YYYY-MM-DD')}</p><p>{dayjs(item.expiration).format('YYYY-MM-DD')}</p>
         </div>
		<i></i>
	    </div>
      </List.Item>
      )}
      />
        </TabPane>
      </Tabs>
    )
  }
}

const CouponDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={830}
    style={{ top: 30 }}
    visible={isOpen}
    onCancel={hide}>
    <CouponDialogComponent onSuccess={hide} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'COUPON_DIALOG',
})(CouponDialog)
